export const baseURL = `http://10.207.129.191:8081/vsnmsas/availability/priorities/v1/`;
export const basePathProxy = process.env.REACT_APP_ELECTION_ENGINE_PROXY_URL;
export const redirectURL = process.env.REACT_APP_ELECTION_ENGINE_REDIRECT_URI;